import {
  FilteredItem,
  FilteredItemProps,
} from '@delmonicos/shared-design-system-react/src/components/filtered-item/filtered-item';
import { GatewayNetworkModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/networks/models/outputs/gateway-network.model';

import { useAppSelector } from '@app/core/hooks';
import { useCpmsBoGetNetworkQuery } from '@app/core/service/cpms-bo-network.service';
import { cpmsBoNetworkSlice } from '@app/core/service/cpms-bo-network.slice';

export interface NetworkFilterStateControllerProps {
  value: GatewayNetworkModel['id'];
  onRemove: FilteredItemProps['onRemove'];
}

export const NetworkFilterStateController = ({
  value,
  onRemove,
}: NetworkFilterStateControllerProps): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  // Nothing to do

  // DATA FETCHING /////////////////////////////////////////////////////////////

  const network = useAppSelector((state) =>
    cpmsBoNetworkSlice.selectors.selectById(state, value),
  );

  const { data: networkApiData } = useCpmsBoGetNetworkQuery(value, {
    skip: !!network,
  });

  const networkName = network?.name ?? networkApiData?.name ?? '';

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <FilteredItem icon="server-06" label={networkName} onRemove={onRemove} />
  );
};
